<template>
  <b-row>
    <b-col cols="12 informacion">
      <b-row
        v-if="
          despacho.tipo &&
          despacho.tipo.subtipo &&
          despacho.tipo.subtipo.tipo_operacion &&
          estados.sub_tipo
        "
      >
        <b-col cols="4" class="text-left dato">
          <p>Sub Tipo</p>
        </b-col>
        <b-col cols="4" class="text-right dato despacho">
          <p v-if="despacho.tipo.subtipo.tipo_operacion">
            {{ despacho.tipo.subtipo.tipo_operacion }}
          </p>
        </b-col>
        <b-col cols="4" class="text-right dato despacho">
          <button
            @click="editar('presentador', 'sub_tipo')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col cols="12" class="text-right dato despacho">
          <form class="form-input">
            <b-row>
              <b-col sm="12" md="12" lg="6">
                <b-form-group
                  class="text-left"
                  label="Sub Tipo"
                  label-for="sub_tipo-select"
                >
                  <select
                    v-if="despacho.tipo_despacho == 'importacion'"
                    id="sub_tipo-select"
                    v-model="sub_tipo"
                    required
                  >
                    <option value="0" disabled>
                      Selecciona el Sub Tipo Importación
                    </option>
                    <option
                      :key="index"
                      v-for="(sub_tipo, index) in listaTipoImportacion"
                      :value="sub_tipo.id"
                    >
                      {{ sub_tipo.tipo_operacion }}
                    </option>
                  </select>
                  <select
                    v-if="despacho.tipo_despacho == 'exportacion'"
                    id="sub_tipo-select"
                    v-model="sub_tipo"
                    required
                  >
                    <option value="0" disabled>
                      Selecciona el Sub Tipo Exportación
                    </option>

                    <option
                      :key="index"
                      v-for="(sub_tipo, index) in listaTipoExportacion"
                      :value="sub_tipo.id"
                    >
                      {{ sub_tipo.tipo_operacion }}
                    </option>
                  </select>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="12" lg="6">
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar('presentador', 'sub_tipo', true, {
                      tipo_id: sub_tipo,
                    })
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="editar('presentador', 'sub_tipo')"
                >
                  Cancelar
                </button>
              </b-col>
            </b-row>
          </form>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
import axios from "axios";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  data() {
    return {
      //importacion
      nombre: "",
      nombre_transporte: "",
      numero_manifiesto: "",
      cliente_id: 0,
      fecha_eta: "",
      aduana_id: "",
      tipo_carga: "",
      caracteristicas_carga: "",
      transporte: "",
      correo_transporte: "",
      sub_tipo: "",

      //exportacion
      estado_presentacion_matriz: "",
      dus_primer_envio: "",
      prorroga: "",
      aforo: 1,

      listaTipoImportacion: [],
      listaTipoExportacion: [],
    };
  },
  mounted() {
    this.getSubTipos();
  },
  methods: {
    cambiarRut(value) {
      this.cliente_rut = value;
    },
    cambiarRutTransporte(value) {
      this.transporte = value;
    },
    async getSubTipos() {
      await axios
        .get("api/admin/despachos/subtipos")
        .then((resp) => {
          this.listaTipoImportacion = resp.data.importaciones;
          this.listaTipoExportacion = resp.data.exportaciones;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
